/* src/app/system-notifications/system-notifications.component.scss */
/*# sourceMappingURL=system-notifications.component.css.map */
